import { all } from "redux-saga/effects"
import { authSaga } from "./authSaga"
import { categorySourceSaga } from "./categorySourceSagas"
import { dictionarySaga } from "./dictionarySagas"
import { hocSinhSelectionSaga } from "./hoc-sinh/hocSinhSelectionSaga"
import { localizedResourceSaga } from "./localized-resource/localizedResourcsSaga"

import { appConfigSaga } from "./common/appConfigSaga"
import { chienDichSaga } from "./crm-survey/chienDichSaga"
import { notifySaga } from "./notify/notifySaga"
import { loaiPhongSaga } from "./phong-hoc/loaiPhongSaga"

import { formItemSaga } from "./form/formItemSaga"
import { formSaga } from "./form/formSaga"

import { uploadSaga } from "./upload-file/uploadSaga"


import { boDoiCongAnSaga } from "./bodoi-congan/boDoiCongAnSaga"
import { conCbnvSaga } from "./con-cbnv/conCbnvSaga"
import { nguonBietToiSaga } from "./crm-category/nguonBietToiSaga"
import { nguonBietToiTypeSaga } from "./crm-category/nguonBietToiTypeSaga"
import { crmHocSinhSaga } from "./crm-hocsinh/crmHocSinhSaga"
import { crmPhuHuynhSaga } from "./crm-phuhuynh/crmPhuHuynhSaga"
import { crmSurveyFormQuestionSaga } from "./crm-survey/crmSurveyFormQuestionSaga"
import { giaoVienSaga } from "./danh-muc/giaoVienSaga"
import { loaiSucKhoeSaga } from "./danh-muc/loaiSucKhoeSaga"
import { lopSaga } from "./danh-muc/lopSaga"
import { sucKhoeSaga } from "./danh-muc/sucKhoeSaga"
import emailSagaWrapper from "./email/emailSagaWrapper"
import { hocSinhAceChiTietSaga } from "./hoc-sinh/hocSinhAceChiTietSaga"
import { hocSinhAceSaga } from "./hoc-sinh/hocSinhAceSaga"
import thongKeSagaWrapper from "./thong-ke/thongKeSagaWrapper"
import { thongTinCbnvSaga } from "./thongtin-cbnv/thongTinCbnvSaga"
import { foCaAnSaga } from "./thuc-don/foCaAnSaga"
import { foCaAnTruongSaga } from "./thuc-don/foCaAnTruongSaga"
import { foMonAnChiTietSaga } from "./thuc-don/foMonAnChiTietSaga"
import { foThucDonSaga } from "./thuc-don/foThucDonSaga"
import { trangThaiHocSinhSaga } from "./trang-thai-hoc-sinh/trangThaiHocSinhSaga"
import { trangThaiPhuHuynhSaga } from "./trang-thai-phu-huynh/trangThaiPhuHuynhSaga"
import { hinhThucMienGiamSaga } from "./hinh-thuc-mien-giam/hinhThucMienGiamSaga"


export default function* rootSaga() {
  yield all([
    authSaga(),
    dictionarySaga(),
    categorySourceSaga(),
    hocSinhSelectionSaga(),
    loaiPhongSaga(),
    uploadSaga(),
    notifySaga(),
    localizedResourceSaga(),
    appConfigSaga(),
    formSaga(),
    formItemSaga(),
    crmSurveyFormQuestionSaga(),
    nguonBietToiSaga(),
    nguonBietToiTypeSaga(),
    chienDichSaga(),
    trangThaiHocSinhSaga(),
    trangThaiPhuHuynhSaga(),
    emailSagaWrapper(),
    trangThaiPhuHuynhSaga(),
    crmHocSinhSaga(),
    foCaAnSaga(),
    foCaAnTruongSaga(),
    foMonAnChiTietSaga(),
    foThucDonSaga(),
    crmPhuHuynhSaga(),
    giaoVienSaga(),
    sucKhoeSaga(),
    loaiSucKhoeSaga(),
    hocSinhAceSaga(),
    hocSinhAceChiTietSaga(),
    thongTinCbnvSaga(),
    conCbnvSaga(),
    boDoiCongAnSaga(),
    thongKeSagaWrapper(),
    lopSaga(),
    hinhThucMienGiamSaga(),
  ]);
}
